import { formatName } from '@/utils/name/formatName';
import { getCountryNameByCode } from '@/utils/name/getCountryName';
import { formatInternationalNumber } from '@/utils/number/formatInternationalNumber';
import styled from 'styled-components';
import { GetPartnerBusinessProfileResponse } from '@/api/type/types';
import { useTranslation } from 'react-i18next';
import { fonts } from '@/theme/fonts';

interface AccountInfoProps {
  profile: GetPartnerBusinessProfileResponse;
}

const AccountInfo = ({ profile }: AccountInfoProps) => {
  const { t } = useTranslation();
  return (
    <Container>
      <Title>{t('accountInfo')}</Title>
      <Section>
        <Row>
          <Label>{t('id2')}</Label>
          <Value>{profile.loginId}</Value>
        </Row>
        <Row>
          <Label>{t('name2')}</Label>
          <Value>
            {formatName({
              countryCode: profile.name.countryCode,
              firstName: profile.name.firstName,
              lastName: profile.name.lastName,
            })}
          </Value>
        </Row>

        <Row>
          <Label>{t('nationality')}</Label>
          <Value>
            {getCountryNameByCode({
              contactCountryCode: profile.name.countryCode,
              countryCode: profile.countryCode,
            })}
          </Value>
        </Row>

        <Row>
          <Label>{t('contactNo')}</Label>
          <Value>
            {formatInternationalNumber({
              countryCode: profile.name.countryCode,
              number: profile.contactNumber,
            })}
          </Value>
        </Row>
      </Section>
    </Container>
  );
};

export default AccountInfo;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  text-align: start;
  gap: 5px;
  flex: 1;
`;

const Title = styled.div`
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: 140%;
  color: #000000;
`;

const Section = styled.div`
  padding: 21px 43px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  border-radius: 10px;
  background: rgba(106, 150, 248, 0.3);
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: 160px 1fr;
  align-items: center;
`;

const Label = styled.div`
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: 140%;
  color: #ffffff;
`;

const Value = styled.div`
  font-weight: ${fonts.weight.bold};
  font-size: 20px;
  line-height: 140%;
  color: #000000;
`;
